<script lang="ts">
	import type { CurrencyRange } from 'utility/search-fields'
	import type { ComponentProps } from 'svelte'

	import Pin from 'components/search/Pin.svelte'
	import CurrencyInput from '@isoftdata/svelte-currency-input'

	interface Props extends Omit<ComponentProps<typeof CurrencyInput>, 'value' | 'change'> {
		label: string
		from?: string
		to?: string
		disabled?: boolean
		isPinned?: boolean
		change?: (value: CurrencyRange) => void
	}

	let {
		//
		label,
		from = $bindable(''),
		to = $bindable(''),
		disabled = false,
		isPinned = false,
		change,
		...rest
	}: Props = $props()
</script>

<label
	for="currencyRangeFrom"
	class="col-form-label pb-0"
	>{label} <Pin {isPinned} />
</label>
<div class="form-row">
	<div class="col-12 col-md-6">
		<CurrencyInput
			{...rest}
			id="currencyRangeFrom"
			label="From"
			{disabled}
			bind:value={from}
			change={() => {
				if (from && (!to || parseFloat(to) === 0)) {
					to = from
				}
				change?.({ from, to })
			}}
		></CurrencyInput>
	</div>
	<div class="col-12 col-md-6">
		<CurrencyInput
			{...rest}
			label="To"
			{disabled}
			bind:value={to}
			change={() => change?.({ from, to })}
		></CurrencyInput>
	</div>
</div>
